import { arrayOf, func, string } from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

import ActiveView from '../../associations/Association/ActiveView';
import createModalToggle from '../../generic/create-modal-toggle';
import SingleSelect from '../../generic/SingleSelect';
import api from '../../REST/api';
import { flash, tapFlashError, tapFlashSuccess } from '../../utils/flash';
import { merchantFrameworkOptions } from '../constants';

const MerchantsBulkEditor = ({ selectedItems, toggle }) => {
  const [newPcId, setPcId] = useState(null);
  const [newMerchantFramework, setMerchantFramework] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const history = useHistory();
  const isPC = str => str.toLowerCase().includes('pc');

  const handleChange = event => {
    const { name, value } = event.target;
    if (isPC(name)) setPcId(value);
    else setMerchantFramework(value);
  };

  const update = async event => {
    const { name } = event.target;
    setIsSaving(true);
    flash('Saving the selected merchants...', 'info');
    const updateObj = isPC(name)
      ? { pcId: newPcId }
      : { framework: newMerchantFramework };
    try {
      await Promise.all(
        selectedItems.map(async merchantId => {
          const id = Number.parseInt(merchantId, 10);
          const zmsamMerchant = await api.getZMSAMMerchant({
            id,
            search: { _fields: 'name' },
          });
          return api
            .patchZMSAMMerchant({ id, data: updateObj })
            .catch(tapFlashError())
            .catch(() => {
              tapFlashError()(
                new Error(
                  `There was a problem while trying to update ${zmsamMerchant.name}`,
                ),
              );
            });
        }),
      );
      tapFlashSuccess('All merchants saved successfully')();
      // setTimeout allows the user to know changes were successfull by letting the success flash message appears before the page is refreshed.
      setTimeout(() => {
        history.go();
      }, '1000');
      // eslint-disable-next-line no-empty
    } catch (e) {
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <ModalHeader toggle={toggle}>Edit the selected merchants</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup row className="align-items-center">
            <Label for="bulk.pcId" sm={2}>
              PC
            </Label>
            <Col sm={8}>
              <ActiveView
                isMulti={false}
                id="bulk.pcId"
                onSelectBlur={() => {}}
                name="pcId"
                value={newPcId}
                type="user"
                onChange={handleChange}
              />
            </Col>
            <Col sm={2}>
              <Button name="updatePC" onClick={update} disabled={isSaving}>
                Update
              </Button>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="bulk.merchantFramework" sm={2}>
              Merchant Framework
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={merchantFrameworkOptions}
                id="bulk.merchantFramework"
                name="merchantFramework"
                value={newMerchantFramework}
                onChange={handleChange}
              />
            </Col>
            <Col sm={2}>
              <Button
                name="updateFramework"
                onClick={update}
                disabled={isSaving}
              >
                Update
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </ModalBody>
    </>
  );
};

MerchantsBulkEditor.propTypes = {
  selectedItems: arrayOf(string).isRequired,
  toggle: func.isRequired,
};

export default createModalToggle(
  'Edit selected merchants',
  MerchantsBulkEditor,
  { outline: true },
  { size: 'lg' },
);
